module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "flex": "1 0 auto"
    }
  }, [(!_vm.inTheProcessOfClosing) ? _c('AppButtonNew', {
    staticClass: "ui_bgcolor__dark-red ui_color__white",
    staticStyle: {
      "flex": "1 0 auto"
    },
    on: {
      "click": _vm.startCancel
    }
  }, [_vm._v("Отменить")]) : _c('div', {
    staticClass: "cancellation d-flex",
    staticStyle: {
      "flex": "1 0 auto"
    }
  }, [_c('AppButtonNew', {
    staticClass: "me-3 ui_bgcolor__dark-red",
    staticStyle: {
      "flex": "1 0 auto"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Да")]), _c('AppButtonNew', {
    staticClass: "ui_bgcolor__green-successful",
    staticStyle: {
      "flex": "1 0 auto"
    },
    on: {
      "click": _vm.stopCancel
    }
  }, [_vm._v("Нет")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bea7bba","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/components/cancellation/Cancellation.vue
// module id = f873344b6bfc67eeac39
// module chunks = 89